import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-section-header',
    templateUrl: './section-header.component.html',
    styleUrls: ['./section-header.component.scss']
})
export class SectionHeaderComponent {
    @Input() text = '';
    @Input() topBorder = false;
}
